export const getProvisionalInvoicePrintCode = (invoice) => {
  const invoiceCode = String(invoice?.pin_print || "").trim();
  if (invoiceCode) return invoiceCode;

  const orders = Array.isArray(invoice?.orders) ? invoice.orders : [];
  const orderWithPrintCode = orders.find(
    (order) => String(order?.pin_print || "").trim() !== "",
  );

  return String(orderWithPrintCode?.pin_print || "").trim();
};
